























































































import {Vue, Component, Ref} from 'vue-property-decorator';
import {namespace} from 'vuex-class';

import CompSelectBox from '@/components/common/CompSelectBox.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import ReviewTabs from '@/components/product/review/ReviewTabs.vue';
import ExcelUploadResult from '@/views/product/review/ExcelUploadResult.vue';

import {i18nAllObject, i18nInObjectList} from '@/utils/i18n';
import { writeExcel } from '@/utils/excel';
import {changeDateFormat} from '@/utils/dateUtils';
import {gridModelToExcel, ncpPopup} from '@/utils/ncp';
import {
  Mall,
  GetReviewsConfigurationsExcludedProductsRequest,
  PostReviewsConfigurationsExcludedProductsExcelBulk,
  NCPResponse,
  PutReviewsConfigurationsExcludedProductsSyncRequest
} from 'ncp-api-supporter';
import { getStorageByName } from '@/utils/excel';
import {ReviewsConfigurationsExcludedProductsContents} from 'ncp-api-supporter/dist/types/modules/display/review';
import TuiGrid from 'tui-grid';

type InvalideTextType = '' | 'EVENT_ADDFORM_ONLY_NUMBER_COMA' | 'PRODUCT_REVIEW_VALIDATE_TXT_LESS_THEN_10_CHAR';

const mallModule = namespace('mall');
const DEFAULT_PAGE_SIZE = 100;
Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    CompSelectBox,
    ItemTable,
    ReviewTabs,
    ExcelUploadResult
  }
})
export default class ReportExceptSetting extends Vue {
  @Ref('exception-grid') exceptionGrid: ItemTable;
  @Ref ('file') fileRef: HTMLInputElement;

  // 쇼핑몰
  @mallModule.Action('fetchMalls')
  fetchMalls!: () => Promise<any>;
  @mallModule.Getter('malls')
  private readonly malls!: Mall[];

  private mallNo = 0;
  private products: ReviewsConfigurationsExcludedProductsContents[] = [];
  private productNoField = '';
  private availableProductNos: number[] = [];
  private deleteProductNos: number[] = [];

  private invalidMessage: InvalideTextType = '';
  private isDisplayPopup = false;
  private uploadExcelResult: PostReviewsConfigurationsExcludedProductsExcelBulk = {
    requestedCount: 0,
    successCount: 0,
    failCount: 0,
    failHistoryId: '',
    registeredProductNos: []
  };

  private readonly tableOption = {
    name: 'exception-grid',
    haveExcelDownBtn: false,
    onLoadSearch: false,
    pageSize: DEFAULT_PAGE_SIZE,
  };

  private gridProps = {
    header: {
      height: 33
    },
    options: {
      columnOptions: {
        resizable: true
      },
      rowHeaders: ['checkbox'],
      rowHeight: 31,
      bodyHeight: 600,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,
      minRowHeight: 31,
      keyColumnName: 'productNo',
      pageOptions: {
        page: 1,
        perPage: 100,
        totalCount: 0
      }
    },
    columns: [
      {
        header: 'PRODUCT_REVIEW_HEADER_MALLNO',
        name: 'mallName',
        align: 'center',
        minWidth: 100,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_PRODUCT_NUMBER',
        name: 'productNo',
        align: 'center',
        formatter: ({value}: any) => `<a href="/product/edit?mallProductNo=${value}" target="_blank">${value}</a>`

      },
      {
        header: 'PRODUCT_REVIEW_PRODUCT_NAME',
        name: 'productName',
        align: 'center'
      },
      {
        header: 'PRODUCT_REVIEW_PARTNER',
        name: 'partnerName',
        align: 'center'
      },
      {
        header: 'PRODUCT_ADD_DISCOUNT_PRICE',
        name: 'appliedImmediateDiscountPrice',
        align: 'center'
      },
      {
        header: 'PRODUCT_PRODUCT_ADMIT_STATUS',
        name: 'applyStatusType',
        align: 'center',
        formatter: ({value}: any): string => this.$t(`DISPLAY_CATEGORIES_${value}`) as string
      },
      {
        header: 'PRODUCT_PRODUCTLIST_SALES_STATUS',
        name: 'saleStatusType',
        align: 'center',
        formatter: ({value}: any): string => this.$t(`PRODUCT_SELECT_ADDFORM_${value}`) as string
      },
      {
        header: 'CLAIM_EXCHANGEPRODUCT_CATEGORYTYPE',
        name: 'displayCategoryNames',
        align: 'center'
      },
      {
        header: 'COMMON_DELETE',
        name: 'delete',
        align: 'center',
        renderer: ({rowKey}) => {
          const buttonEl = document.createElement('button');
          const handleClickEvent = () => {
            if (!confirm(this.$t('PRODUCT_REVIEW_CONFIRM_DELETE_PRODUCT').toString())) return;

            this.handleDeleteItem(rowKey);
          };
          buttonEl.textContent = window.$t('COMMON_DELETE');
          buttonEl.addEventListener('click', handleClickEvent);

          return {
            getElement(): HTMLButtonElement {
              return buttonEl;
            },
            render(): void {}
          };
        }
      },
    ]
  };

  private prevMallNo = 0;
  /**
   * comp-select-box 의 model 값은 변하지만
   * re render가 되지 않아
   * v-key를 이용해 key를 변경시켜 re render 시킨다.
   */
  private reRenderKey = 0;
  private handleChangeMall() {
    if (!this.availableProductNos.length && !this.deleteProductNos.length && !this.productNoField.length) {
      this.prevMallNo = this.mallNo;
      this.search();
      return;
    }

    if (!confirm(this.$t('PRODUCT_REVIEW_CONFIRM_NOT_YET_SAVED').toString())) {
      this.mallNo = this.prevMallNo;
      this.reRenderKey += 1;
      return;
    }

    this.prevMallNo = this.mallNo;

    this.reset();
    this.search();
    return;
  }

  private async search(pageNumber = 1, pageSize = DEFAULT_PAGE_SIZE) {

    const request: GetReviewsConfigurationsExcludedProductsRequest = {
      params: {
        pageNumber,
        pageSize,
        mallNo: this.mallNo,
        hasTotalCount: true,
        productNosBeSaved: this.availableProductNos.join(','),
        productNosBeDeleted: this.deleteProductNos.join(',')
      }
    };

    try {
      const { data } = await this.$api.getReviewsConfigurationsExcludedProducts(request);

      this.products = data.items;
      this.gridProps.options.pageOptions.page = pageNumber;
      this.gridProps.options.pageOptions.perPage = pageSize;
      this.gridProps.options.pageOptions.totalCount = data.totalCount;
      this.productNoField = '';
    } catch (err) {
      console.error(err);
    }
  }


  private handleCloseModal() {
    this.isDisplayPopup = false;

    if (!this.uploadExcelResult.successCount) return;

    this.availableProductNos = [...this.uploadExcelResult.registeredProductNos];
    this.search();
  }

  private validateMallNo(): boolean {
    if (this.mallNo !== 0) return true;

    alert(this.$t('BOARD_NOTICE_EDIT_ALERT_MALL'));
    return false;
  }

  private setAvailableNos(list: number[]) {
    const combineDatas = [ ...this.availableProductNos, ...list ];
    const filteredData = [ ...new Set(combineDatas) ];

    return [ ...this.availableProductNos, ...filteredData.filter((item) => !this.products.find(product => product.productNo === item))];
  }

  private handleSearchProducts() {
    if (!this.validateMallNo()) return;

    const LIMIT = 500;

    (window as any).productCallBack = (res) => {
      this.availableProductNos = this.setAvailableNos(res.map(item => item.mallProductNo));
      this.search();
    };
    const url = `/product/search/popup?mallNo=${this.mallNo}&callBackName=productCallBack&&limit=${LIMIT}&allBtn=true&customProperty=true&noConfirm=true&pageType=exception`;
    ncpPopup(url, this.$t('ORDER_MANUAL_ORDER_PRODUCT_POP_TITLE'), 1250, 1024);
  }

  private get mallList() {
    return this.malls
          .filter(mall => mall.used)
          .map(mall => ({value: mall.mallNo, name: mall.mallName}))
  }

  private validateField(values: string): boolean {
    const nums = values.trim().replace(/\r\n|\n/g, ',').replace(/\s/g, '').split(',');
    const MAX_NUMBER_LENGTH = 9;
    const isOverMax = nums.some(num => num.length > MAX_NUMBER_LENGTH);
    const isAllCurrectNumber = nums.every((num): boolean => /^\d+$/.test(num));

    if (!isAllCurrectNumber) {
      this.invalidMessage = 'EVENT_ADDFORM_ONLY_NUMBER_COMA';
      return false;
    }

    if (isOverMax) {
      this.invalidMessage = 'PRODUCT_REVIEW_VALIDATE_TXT_LESS_THEN_10_CHAR';
      return false;
    }

    this.invalidMessage = '';
    this.productNoField = nums.join(',');
    return true;
  }

  // 삭제
  private handleDeleteItems() {
    const checkedItems = this.exceptionGrid.gridFunction('getCheckedRows');
    if (!checkedItems.length) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_12'));
      return;
    }

    if (!confirm(this.$t('PRODUCT_REVIEW_CONFIRM_DELETE').toString())) return;

    checkedItems.forEach(item => this.handleDeleteItem(item.productNo));
  }

  private handleDeleteItem(productNo: number) {
    this.deleteProductNos.push(productNo);
    this.products = this.products.filter((item) => item.productNo !== Number(productNo));
    this.availableProductNos = this.availableProductNos.filter((item) => item !== Number(productNo));
  }

  // 상품추가
  private async handleDirectRegistrationProduct() {
    if (!this.validateMallNo()) {
      this.productNoField = '';
      return;
    }
    if (!this.productNoField.length) return alert(this.$t('PRODUCT_REVIEW_NO_DATA'));
    if (!this.validateField(this.productNoField)) return;

    const request = {
      params: {
        mallNo: this.mallNo,
        productNos: this.productNoField,
      }
    }

    try {
      const { data } = await this.$api.getReviewsConfigurationsExcludedProductsAvailable(request);
      const { availableProductNos, notAvailableProductNos } = data;
      const totalLength = availableProductNos.length + notAvailableProductNos.length;

      if (!availableProductNos.length && notAvailableProductNos.length) return alert(this.$t('DISPLAY_CATEGORIES_NO_REGISTER'));

      if (availableProductNos.length
          && notAvailableProductNos.length
          && !confirm(
                String(
                  this.$t('PRODUCT_REVIEW_CONFIRM_VALID_INVALID_COUNT', {
                    n: totalLength,
                    m: notAvailableProductNos.length,
                    no: notAvailableProductNos.join(',')
                  })
                )
          )
      ) return;

      if (availableProductNos.length
          && !notAvailableProductNos.length
          && !confirm(this.$t('PRODUCT_REVIEW_CONFIRM_ADD_EXCEPTIONAL_PRODUCT').toString())) return;

      this.availableProductNos = this.setAvailableNos(availableProductNos);
      this.search();

    } catch (err) {
      console.error(err);
    }
  }

  // 초기화
  private reset() {
    this.productNoField = '';
    this.products = [];
    this.availableProductNos = [];
    this.deleteProductNos = [];
  }

  private getExcelFormData(file: File): FormData | null {
    const isCorrectExe = ['xlsx', 'xls'].some(exe => file.name.includes(exe));
    const formData = new FormData();

    if (!isCorrectExe) {
      return null;
    }

    formData.append('excelFile', file);
    formData.append('mallNo', this.mallNo.toString());
    return formData;
  }

  private async postExcelFile(file: FormData): Promise<PostReviewsConfigurationsExcludedProductsExcelBulk> {
    try {
      const {data} :NCPResponse<PostReviewsConfigurationsExcludedProductsExcelBulk> =  await this.$api.postReviewsConfigurationsExcludedProductsExcelBulk({ data: file });
      return data;
    } catch (err) {
      console.error(err);
    }
  }

  private handleDownloadExcelForm() {
    getStorageByName('상품후기 작성불가 상품 엑셀업로드 양식.xlsx', 'Upload_Review_ProductNo_Sample.xlsx','excel-sample');
  }

  private resetExcelUploader() {
    this.fileRef.value = '';
  }

  private async handleAddExcelFile({ target }: {target: HTMLInputElement }) {
    if (!this.validateMallNo()) return;

    const file = target.files[0];
    const formData = this.getExcelFormData(file);
    if (!formData) {
      alert(this.$t('PRODUCT_REVIEW_INCORRECT_EXCEL_FORM'));
      this.resetExcelUploader();
      return;
    }
    this.uploadExcelResult = await this.postExcelFile(formData);
    this.isDisplayPopup = true;
  }

  private async handleSave() {
    if (!this.availableProductNos.length && !this.deleteProductNos.length && !this.productNoField.length) {
      alert(this.$t('DISPLAY_CATEGORIES_NO_CHANGE'));
      return;
    }

    const request: PutReviewsConfigurationsExcludedProductsSyncRequest = {
      data: {
        mallNo: this.mallNo,
        productNosForDelete: this.deleteProductNos,
        productNosForSave: this.availableProductNos
      }
    };
    try {
      await this.$api.putReviewsConfigurationsExcludedProductsSync(request);
      alert(this.$t('PRODUCT_REVIEW_SAVED'));
      this.reset();
      this.search();
    } catch(err) {
      console.error(err);
    }
  }

  private async handleDownloadReviewExcel() {
    if (!this.validateMallNo()) return;

    const columnTitles = {
      mallName: 'PRODUCT_REVIEW_HEADER_MALLNO',
      productNo: 'PRODUCT_REVIEW_PRODUCT_NUMBER',
      productName: 'PRODUCT_REVIEW_PRODUCT_NAME',
      partnerName: 'PRODUCT_REVIEW_PARTNER',
      appliedImmediateDiscountPrice: 'PRODUCT_ADD_DISCOUNT_PRICE',
      applyStatusType: 'PRODUCT_PRODUCT_ADMIT_STATUS',
      saleStatusType: 'PRODUCT_PRODUCTLIST_SALES_STATUS',
      displayCategoryNames: 'CLAIM_EXCHANGEPRODUCT_CATEGORYTYPE'
    };
    const fileName = `review_product_${changeDateFormat(new Date(), 'YYYYMMDD')}`;
    const columns = i18nAllObject(this, columnTitles)
    const model = gridModelToExcel(this.gridProps.columns);

    model.formatter['productNo'] = ({row}) => `${row.productNo}`;

    writeExcel(this.products, columns, fileName, model.formatter);
  }

  private changePageSize(args, pageSize) {
    // item table에서 arg: 1, Number(변경된 옵션값)이 넘어옴
    this.search(args, pageSize);
  }

  private created() {
    const labelForEmpty = this.$t('PRODUCT_SELECT_ADDFORM_NO_DATA') as string;
    TuiGrid.setLanguage('ko', { display: { noData: labelForEmpty }})
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.mallNo = this.malls[0].mallNo;
    this.prevMallNo = this.malls[0].mallNo;
    this.search();
  }

  beforeRouteLeave(to, from, next) {
    if ((this.availableProductNos.length
        || this.deleteProductNos.length)
        && !confirm(this.$t('COMMON_TREE_ALERT_NOT_SAVED').toString())) return;

    next();
  }

}
